import type { NewsletterRecommendations } from '../../../../generated/frontend'
import type { NewsletterData } from './newsletterData'
import { newslettersOrderedByPopularity } from './newsletterData'

export const getMostPopularUnsubscribedNewsletters = (
  subscribedNewslettersCodes: string[]
): NewsletterData[] => {
  const results: NewsletterData[] = []
  for (let i = 0; i < newslettersOrderedByPopularity.length; i++) {
    const { code } = newslettersOrderedByPopularity[i]

    if (!subscribedNewslettersCodes.includes(code)) {
      results.push(newslettersOrderedByPopularity[i])
    }
  }
  return results
}

export const getNewsletterRecommendations = ({
  subscribed,
  newsletterRecommendations,
}: Args): NewsletterData[] => {
  if (newsletterRecommendations && newsletterRecommendations.length > 0) {
    const newsletters: NewsletterData[] = []
    const recommendations = [...newsletterRecommendations]
      .sort((a, b) => b.newsletterRelevance.modelV1 - a.newsletterRelevance.modelV1)
      .filter(({ id }) => !subscribed.includes(id))
    recommendations.forEach(({ id }) => {
      const newsletterData = newslettersOrderedByPopularity.find(({ code }) => code === id)
      if (newsletterData) {
        newsletters.push(newsletterData)
      }
    })
    return newsletters
  } else {
    return getMostPopularUnsubscribedNewsletters(subscribed)
  }
}

type Args = {
  subscribed: string[]
  newsletterRecommendations?: NewsletterRecommendations['newsletterRecommendations']
}
